import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './vati.css'

const Vati = (props) => {
  return (
    <div className="vati-container1">
      <Helmet>
        <title>Albert Woltjes - marjangerrits.nl</title>
        <meta
          name="description"
          content="Albert Woltjes bij het Jungvolk, Hiterljugend."
        />
        <meta property="og:title" content="Albert Woltjes - marjangerrits.nl" />
        <meta
          property="og:description"
          content="Albert Woltjes bij het Jungvolk, Hiterljugend."
        />
      </Helmet>
      <NavbarInteractive rootClassName="navbar-interactiveroot-class-name11"></NavbarInteractive>
      <div className="vati-container2">
        <div className="vati-container3">
          <img
            alt="image"
            src="/Blog foto's/albert%20woltjes%20hj-700w.jpg"
            className="vati-foto"
          />
          <div className="vati-container4">
            <span className="vati-titel">
              <span>Albert Woltjes</span>
              <br></br>
              <span className="Schuingedrukt_tekst">
                24 juni 1925 - 25 mei 1988
              </span>
              <br></br>
            </span>
            <p className="vati-datum">
              <span>25-05-2023</span>
              <br></br>
            </p>
            <p className="vati-text16">
              Vandaag is het vijfendertig jaar geleden dat mijn Duitse
              schoonvader, die net als mijn vader Albert heette, overleden is.
              Ik had hem graag leren kennen. Niet alleen omdat hij de vader van
              mijn lief is, maar ook omdat ik nieuwsgierig ben hoe hij in de
              oorlog was. Ik had hem willen vragen naar zijn jeugd, hoe hij de
              Tweede Wereldoorlog ervaren heeft. En, na moed verzameld te
              hebben, zou ik gevraagd hebben of hij gevochten heeft, mensen
              gedood heeft.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </p>
          </div>
        </div>
        <p className="vati-text17">
          <br></br>
          <span>
            In de familie werd er zelden over de oorlog gesproken. Veel weten ze
            mij dan ook niet te vertellen. Het vraagstuk laat me niet los, het
            familiearchief is enorm en ik heb besloten op onderzoek uit te gaan
            en daarover te schrijven. Zie ook
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <Link to="/roman" className="vati-navlink">
            Roman
          </Link>
          <span>
            {' '}
            elders op de site.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <br></br>
          <span>
            Laat ik beginnen bij het begin, bij de foto, toen mijn schoonvader
            tien jaar jong was. Hij was net lid geworden van de Hitlerjugend en
            had voor het eerst zijn ‘pakkie an’. Letterlijk en figuurlijk. Was
            hij trots dat hij erbij mocht horen? Ik denk het wel, zijn grote
            broer had het voorbeeld al gegeven. Veel sport en spel, geleid
            worden door de jeugd, kameraadschap, onderdeel zijn van iets
            groters.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <br></br>
          <span className="Schuingedrukt_tekst">
            ‘Ik beloof in de Hitlerjugend altijd mijn plicht te doen in liefde
            en trouw voor onze Führer en onze vlag, zo waarlijk helpe mij God.’
          </span>
          <br></br>
          <br></br>
          <span className="vati-text29">
            Na het afleggen van de eed ondertekent hij het formulier voor het
            lidmaatschap van het Jungvolk, het onderdeel van de Hitlerjugend
            voor jongens van tien tot veertien jaar. Hij heeft de hele week zijn
            handtekening geoefend. Het is goed gelukt. Trots levert hij het
            formulier in.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br className="vati-text30"></br>
          <br className="vati-text31"></br>
          <span className="vati-text32">
            ‘Pimpf.’ Albert roept naar Hermann die net naar buiten gekomen is en
            hem niet gezien heeft. Hermann reageert niet. Albert roept nog een
            keer, harder nu. ‘Piiiiimpf.’
          </span>
          <br className="vati-text33"></br>
          <span className="vati-text34">
            Hermann kijkt en loopt naar Albert toe. Hij strekt zijn arm schuin
            naar voren en roept: ‘Heil Hitler.’
          </span>
          <br className="vati-text35"></br>
          <span className="vati-text36">
            ‘Heil Hitler, antwoordt Albert en strekt ook zijn arm uit.
          </span>
          <br className="vati-text37"></br>
          <span className="vati-text38">
            Ze lopen door naar het schoolplein waar het Jungvolk bijeenkomt, de
            pimpfen. Het is hun eerste bijeenkomst. Ze zijn het afgelopen jaar
            tien geworden en mogen nu meedoen. Tenminste, als je voldoet aan de
            basisvoorwaarden. Je moet Arisch, Rijksduits en ‘erfgezond’ zijn. En
            dat zijn ze. Godzijdank. Stel dat je Joods zou zijn, of je ouders of
            grootouders. Dan kan je nergens aan meedoen, terwijl al je vrienden
            leuke dingen doen.
          </span>
          <br></br>
          <br></br>
          <span>
            En zo begon zijn opvoeding in het nationaalsocialistische
            gedachtengoed. Een jongen uit een hogere klas, die ik hieronder
            Fritz genoemd heb, kreeg de leiding over een groepje van tien nieuwe
            leden. Hij had immers al een jaar ervaring en in 1936 was de groei
            van nieuwe leden enorm. Als je goed je best had gedaan, werd je het
            jaar erop
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span className="Schuingedrukt_tekst">führer</span>
          <span>
            . Opnieuw iets om trots op te zijn.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <br></br>
          <span className="vati-text46">
            Achter elkaar lopen ze over het plein. Albert vindt het een makkie.
            Als je goed let op de pimpf voor je en luistert naar Fritz die
            ‘links, rechts’ blijft roepen, gaat het vanzelf. Als ze voor de
            derde keer het schoolplein over lopen, stoppen ze plotseling.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br className="vati-text47"></br>
          <span className="vati-text48">‘Peter’, roept Fritz.</span>
          <br className="vati-text49"></br>
          <span className="vati-text50">‘Ja?’</span>
          <br className="vati-text51"></br>
          <span className="vati-text52">
            ‘Stap naar voren, zet je voeten naast elkaar, handen langs je benen
            en je zegt niet ‘ja’ maar ‘ja leider’.’
          </span>
          <br className="vati-text53"></br>
          <span className="vati-text54">
            Peter doet wat van hem verwacht wordt.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br className="vati-text55"></br>
          <span className="vati-text56">
            ‘Je was uit de maat, ik zie het nu nog door de vingers maar je moet
            beter je best doen.’
          </span>
          <br className="vati-text57"></br>
          <span className="vati-text58">
            Peter laat zijn hoofd hangen, schuifelt met zijn voet en zegt
            opnieuw ‘ja leider’.
          </span>
          <br className="vati-text59"></br>
          <span className="vati-text60">
            ‘Nee’, roept Fritz. ‘Je moet recht vooruit kijken en je voeten niet
            bewegen. Nog een keer.’
          </span>
          <br className="vati-text61"></br>
          <span className="vati-text62">
            Peter heft zijn hoofd op, staat stil en roept luid en duidelijk ‘ja
            leider’.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br className="vati-text63"></br>
          <span className="vati-text64">‘Dat is beter.’</span>
          <br></br>
          <br></br>
          <span>
            De Hitlerjugend was één manier om de jeugd mee te krijgen,
            propaganda een andere. Daarover een volgende keer meer.
          </span>
          <br></br>
        </p>
      </div>
      <div className="vati-andere-blogs">
        <h2 className="vati-lees-ook">
          <span>Lees ook:</span>
          <br></br>
        </h2>
        <div className="vati-laatste3-blogposts"></div>
      </div>
      <Footer rootClassName="footerroot-class-name12"></Footer>
    </div>
  )
}

export default Vati
